import { Region } from './environment';

export type DataCenterOption = { value: string; flag: string; name: string; description: string };

/**
 * The data centers an account can be created in. Picked once at signup (or a
 * Vercel install) and never changed, hence the warning beside the cards.
 */
export const DATA_CENTERS: DataCenterOption[] = [
  { value: 'us', flag: '🇺🇸', name: 'United States', description: 'For customers mostly outside Europe' },
  { value: 'eu', flag: '🇪🇺', name: 'Europe', description: 'For customers in the EU or UK' },
];

const DATA_CENTER_FLAGS: Record<string, string> = {
  us: '🇺🇸',
  eu: '🇪🇺',
};

/**
 * Formats an account's data center for display as a compact region badge, e.g.
 * "🇺🇸 US". Returns an empty string for an empty/unknown-to-us value so callers
 * can skip rendering; an unknown non-empty code falls back to the upper-cased
 * code without a flag.
 */
export function formatDataCenterShort(dataCenter: string | null | undefined): string {
  if (dataCenter == null || dataCenter === '') {
    return '';
  }
  const flag = DATA_CENTER_FLAGS[dataCenter] ?? '';
  return `${flag} ${dataCenter.toUpperCase()}`.trim();
}

/**
 * Adds the account's region to a documentation URL. The docs site reads
 * `region=eu` and shows the EU hosts and examples; without it an EU account
 * gets the US ones.
 */
export function docsUrlWithRegion(url: string, region: Region): string {
  const parsed = new URL(url);
  if (region === Region.EU) {
    parsed.searchParams.append('region', Region.EU);
  }
  return parsed.toString();
}

/**
 * The host segment of the tracking script the JavaScript snippet loads —
 * `https://assets.customer.io/assets/<segment>.js`.
 */
export function trackAssetHost(region: Region): string {
  return region === Region.EU ? 'track-eu' : 'track';
}
